import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseResponse } from 'src/app/models/commos/base-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { Resources } from 'src/app/models/maintenance/resources';
import { NotificationsService } from 'src/app/services/notifications.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { FunctionsService, HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService, TableColumns, TableConfiguration, params } from 'brainloper-ui';

@Component({
    selector: 'app-authorize-purchase-order',
    templateUrl: './authorize-purchase-order.component.html',
    styleUrls: ['./authorize-purchase-order.component.scss'],
    standalone: false
})
export class AuthorizePurchaseOrderComponent implements OnInit {

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
      name:"Notificaciones",
    },
    {
    name:"Autorizar Orden de Compra",
    current:true
    }
  ]

  private urlPurchaseOrder: string = `${EndpointDictionary.PurchaseOrder.CRUD_PURCHASE_ORDER}`
  public urlGetTablaResources: string = `${EndpointDictionary.Resources.RESOURCES_TABLE}`
  private urlAuthorizePurchaseOrder: string = `${EndpointDictionary.PurchaseOrder.AUTHORIZE_PURCHASE_ORDER}`

  public view: boolean = false
  public movil: boolean
  public bodyPurchaseOrder: HistoryInventory = {}
  public totalCostItems: number
  public resources: Array<Resources> = [{itemName:''}]

  //Tabla Recursos
 public labels = []
 public reloadResouces = new EventEmitter<any>()
 public paramsResources: params [] = [{ id: 'orderId', value: '0' }]
 public configurationResouces: TableConfiguration = {
   primaryKey: 'id',
 };
 public columnsResouces: TableColumns<Resources>[] = [
  {
    ID: 'itemName',
    label: 'Nombre',
    type: 'combo',
    disregardForEdit: true,
    style: {
      textAlign: 'center',
    },
    paramsCombo: {
      selectionField: 'id',
      visibleField: 'name',
      urlParams:[],
      url: `${EndpointDictionary.Item.ITEM_COMBO}`,
     }
  },
  {
    ID: 'unitMeasurement',
    label: 'Unidad',
    type: 'text',
    disregardForAdd: true,
    disregardForEdit: true,
    style: {
      textAlign: 'center',
      movil: 'no-movil'
    },

  },
  {
    ID: 'amount',
    label: 'Cantidad',
    type: 'number',
    style: {
      textAlign: 'center',
    },
  },
  {
    ID: 'costItem',
    label: 'Costo Item',
    type: 'thousandSeparator',
    style: {
      textAlign: 'center',
      movil: 'no-movil'
    },
  },
  {
    ID: 'totalCostItems',
    label: 'Costo Total Item',
    type: 'thousandSeparator',
    style: {
      textAlign: 'center',
      movil: 'no-movil'
    },
  }

];

  constructor(
    private message: MessageService,
    private activeRoute: ActivatedRoute,
    private http: HttpService,
    private router: Router,
    public notificationService: NotificationsService,
    private functioEter: FunctionsService,
  ) { }

  ngOnInit(): void {
    this.init()
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando información')
    this.activeRoute.queryParamMap
      .subscribe(async(params) => {

          const orderId = params.get('id_orden_compra');
          this.paramsResources = [
            { id: 'orderId', value: orderId},
            { id: 'workOrder', value: '0' }
          ]
          let res: Array<HistoryInventory> = await this.http.getDataBody(`${this.urlPurchaseOrder}/${orderId}`)
          if (res) {
            this.bodyPurchaseOrder = res[0]
            this.bodyPurchaseOrder.receptionDate = this.functioEter.dateIso(res[0].receptionDate)
            this.view = true
            this.message.closeLoading()
          }

      })
  }
  async response($event: string) {
    try {
      if ($event == 'autorizar') {
        this.message.openLoading('Cargando', 'Autorizando notificación')
        let resAuthorize: GenericResponse = await this.http.putDataBody(`${this.urlAuthorizePurchaseOrder}`, {id: this.bodyPurchaseOrder.id} )
        if(resAuthorize){
          if(resAuthorize.notification){
            this.notificationService.emitUpdateNotificationsByNotifications(resAuthorize.notification)
          }
            this.message.closeLoading()
            this.message.SuccessToast('Orden de Compra Autorizada')
            this.router.navigate(["/almacen/orden_compra"])
      }
      }else{
        this.message.Warning('Desea rechazar la Orden de Compra', '', true).then(
          (res: boolean) => {
            if(res==true){
              this.declinePurchaseOrder()
            }
          }
        )
      }

    } catch (error) {
      this.message.Error('Error', error['message'])
    }

  }

  async declinePurchaseOrder(){
    this.message.openLoading('Cargando', 'Rechazando notificación')
    let bodyNotification = {
      descripcion:`Orden de Compra # ${this.bodyPurchaseOrder.consecutive} rechazada `,
      notificado: this.bodyPurchaseOrder.requests
  }
    let resDeletePurchaseOrder: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(`${this.urlPurchaseOrder}/${this.bodyPurchaseOrder.id}`)
    if(resDeletePurchaseOrder['code']===0){
           this.message.closeLoading()
          this.message.SuccessToast('Orden de Compra rechazada')
          this.notificationService.sendNotificationInformative(bodyNotification.descripcion, bodyNotification.notificado)
          setTimeout(() => {
            this.router.navigate(["/inicio"])
          }, 500);
  }else{
      this.message.Error('Error', resDeletePurchaseOrder['message'])
    }
  }

  dataResources($event){ //:InternalDataTable<Array<Resources>>
    this.resources = $event.data
    this.totalCostItems = $event.totalCostItems
    this.labels = [
      {
        label: 'Total:',
        value: `$  ${Intl.NumberFormat('es-CO').format(this.totalCostItems)}`,
        edit:false
      }
    ]
  }
}
